import { type paths as companyPaths } from "@njbsoft/types/company";
import { buildClient, type ApiClientOptions } from "./client";

// Typed openapi-fetch client for the /api/v1/company stack. Same auth
// middleware as the main client — the same personal bearer works on every
// stack because company context is DB-derived per request. Company paths
// carry no /auth/ segment, so the AUTH_PATHS skip-list never short-circuits
// and the 401 refresh-replay applies to every company request.
export function createCompanyApiClient(options: ApiClientOptions) {
  return buildClient<companyPaths>(options);
}

export type CompanyApiClient = ReturnType<typeof createCompanyApiClient>;
